import { useCustomizations } from 'common/context/Customizations';
import { rateLimits } from 'itrvl-pricing';

export const useRates = ({ getCustomizations = useCustomizations } = {}) => {
  const customizations = getCustomizations();
  const marginProtection = customizations?.marginProtection === true;

  return {
    land:
      customizations?.pricingSettings?.landRate ?? (marginProtection ? rateLimits.land.marginProtectionDefault : rateLimits.land.default),
    air: customizations?.pricingSettings?.airRate ?? (marginProtection ? rateLimits.air.marginProtectionDefault : rateLimits.air.default),
    deposit:
      customizations?.pricingSettings?.depositRate ??
      (marginProtection ? rateLimits.deposit.marginProtectionDefault : rateLimits.deposit.default),
    currency: customizations?.pricingSettings?.currencyRate ?? rateLimits.currency.default,
    dmc: customizations?.pricingSettings?.dmcRate ?? (marginProtection ? rateLimits.dmc.marginProtectionDefault : rateLimits.dmc.default),
    rack: customizations?.pricingSettings?.rackRate ?? rateLimits.rack.default,
  };
};
